module.exports = __webpack_public_path__ + "img/20200331144051862.1c9b7492.png";